<div class="title">优惠码</div>
<div class="item" *ngFor="let item of code; let i = index">
  <span>{{ i + 1 }}</span>
  <span class="code">{{ item.code }}</span>
  <span class="time"
    ><app-datetime [text]="item.created_time"></app-datetime
  ></span>
</div>
<div class="button">
  <button mat-flat-button (click)="close()">关闭</button>
</div>
<app-global-loading *ngIf="loading"></app-global-loading>
